



































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { SwScrollView } from '@libs/unified-ui-framework/src/shared/sw-scroll-view';
import { SwForm, SwFormRow } from '@libs/unified-ui-framework/src/shared/sw-form';
import SwDiscreetProgress from './sw-discreet-progress-vertical.vue';
import Ns from './../../../assets/ns.svg';
import CASB from './../../../assets/Icon_Cloud_Email_Security_OrangeColor.svg';
import IconEndpoint from './../../../assets/Icon_Endpoint_SSC_Color.svg';

@Component({
  components: {
    SwIcon,
    SwScrollView,
    SwForm,
    SwFormRow,
    SwDiscreetProgress,
  },
})
export default class SwSecurityCenterInfoModal extends Vue {
  // @Prop()
  // height: number;

  // @Prop()
  // width: number;

  @Prop()
  value: boolean;
  defcon: number = 5;
  defcon4: number = 4;
  height: number = 0;
  width: number = 0;
  displayModal = this.value;
  nsImg = Ns;
  casbImg = CASB;
  endpointImg = IconEndpoint;
  colorArray = [
    { color: '#FD0006', value: 1 },
    { color: '#FD9721', value: 2 },
    { color: '#FDCB2E', value: 3 },
    { color: '#EDE385', value: 4 },
    { color: '#97CC2D', value: 5 }];
  start() {
    this.height = this.$el.clientHeight;
    this.width = this.$el.clientWidth;
  }
  @Watch('value')
  onDisplayChange(val: boolean) {
    this.displayModal = val;
  }

  @Watch('displayModal')
  onInternalDisplayChange() {
    this.$emit('input', this.displayModal);
  }
}
